import React from 'react';
import {Tabs, Tab} from 'react-bootstrap';
import {getNumOfItemsInOrderText} from '../../common/basket';
import StoreItemsList from "./StoreItemsList";
import StoreOrderSummary from "../../containers/store/StoreOrderSummary";
import StoreCartDeliveryDate from '../../components/store/StoreCartDeliveryDate';
import StoreCategoriesList from './StoreCategoriesList';
import RecurringOrderItems from "../../containers/store/RecurringOrderItems";
import {translate} from '../../i18n/translate.js';
import StoreSearch from "./StoreSearch";

const STORE_TAB = "STORE";
const CART = "CART";

export class StoreTabsWrapper extends React.Component {
    state = {
        activeKey: STORE_TAB
    };

    componentWillReceiveProps(nextProps) {
        if(!nextProps.showUpdateRecurringModal && this.props.showUpdateRecurringModal !== nextProps.showUpdateRecurringModal) {
            this.setState({activeKey:CART});
        }
    }

    getTabsOrRecurring = () => {
        if(this.props.showUpdateRecurringModal) {
            return(<RecurringOrderItems/>);
        }
        const showAllItems = this.props.staticData.storeNoCategories;
        const numOfItems = getNumOfItemsInOrderText(this.props.orderedItems, this.props.extraCreditItem);
        return (<Tabs defaultActiveKey={this.state.activeKey} animation={false} className="store-mobile-tabs" id="store-mobile-tabs">
            <Tab eventKey={STORE_TAB} title={translate(this.props.staticData.storeButtonLabel.toUpperCase())}>
                <div className="categories-mobile">
                    <StoreSearch/>
                    {!showAllItems ?
                        <StoreCategoriesList categories={this.props.categories}/>
                        :
                        <div className="no-categories"/>
                    }
                    <StoreItemsList className="items-container" itemsList={showAllItems ? this.props.allItems : this.props.itemsList} itemsInRow={this.props.itemsInRow}
                                    itemKey={this.props.itemKey} activeOrder={this.props.activeOrder}
                                    categories={this.props.allItems ? this.props.categories : undefined}
                                    staticData={this.props.staticData}/>
                </div>
            </Tab>
            <Tab eventKey={CART} title={translate('CART') + "(" + numOfItems + ")"}><StoreOrderSummary items={this.props.allItems} /></Tab>
        </Tabs>);
    };

    render() {
        return (
            <div>
                <StoreCartDeliveryDate nextDeliveryDate={this.props.nextDeliveryDate}
                                       remainingCredits={this.props.remainingCredits}
                                       remainingBalanceAsCredits={this.props.remainingBalanceAsCredits}
                                       isCreditItemAsRegularItem={this.props.isCreditItemAsRegularItem}
                                       creditItemLabel={this.props.creditItemLabel}
                                       multiplePickupSitesDates={this.props.multiplePickupSitesDates}
                                       staticData={this.props.staticData}
                                       totals={this.props.totals}
                                       isXs={true}/>
                {this.getTabsOrRecurring()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/store/StoreTabsWrapper.js